<!--
InlineMessage Component — wraps PrimeVue Message for inline alerts/banners.

Use to surface contextual feedback (info/success/warn/error) inside forms,
modals, or page content. Forwards all PrimeVue Message attrs and the default
slot for the message body.
-->

<template>
  <PrimeMessage v-bind="$attrs">
    <slot />
  </PrimeMessage>
</template>

<script setup lang="ts">
import PrimeMessage from 'primevue/message';

defineOptions({ name: 'InlineMessage', inheritAttrs: false });
</script>
